import type { Dict } from "./tr";

export const en: Dict = {
  brand: { name: "SDIP AI", core: "ATLAS", tagline: "Premium Sports Intelligence" },
  nav: {
    product: "Product", live: "Live", prematch: "Prematch", atlas: "ATLAS Assistant",
    performance: "Performance", pricing: "Membership", faq: "FAQ", login: "Log in", register: "Sign up",
    dashboard: "Overview", matchDetail: "Match Analysis", history: "Signal History",
    notifications: "Notifications", membership: "Membership", account: "Account", settings: "Settings",
    analysis: "My Analysis",
    coupons: "Coupon Center", support: "Help & Support", admin: "Admin Center",
  },
  common: {
    loading: "Loading…", retry: "Retry", refresh: "Refresh", viewAll: "View all",
    search: "Search", filter: "Filter", all: "All", live: "Live", min: "min", odds: "Odds",
    refOdds: "Reference odd", confidence: "Confidence", risk: "Risk", market: "Market", explanation: "Explanation",
    score: "Score", finalScore: "Final score", momentum: "Momentum", pressure: "Pressure",
    shots: "Shots", shotsOn: "On target", corners: "Corners", kickoff: "Kickoff", signalId: "Signal ID",
    resolved: "Resolved", none: "—", upgrade: "Upgrade", locked: "Locked", back: "Back",
    learnMore: "Details", getStarted: "Get started", openApp: "Open app", generatedAt: "Updated",
    priceSoon: "Pricing soon", riskUnavailable: "Risk data unavailable",
  },
  states: {
    emptyLiveTitle: "No active signals right now.",
    emptyLiveHint: "ATLAS keeps watching live matches.",
    emptyPrematch: "No upcoming matches ATLAS is evaluating right now.",
    emptyHistory: "No records found.",
    emptyNotifications: "No new notifications.",
    unavailable: "This data is currently unavailable.",
    noConnection: "Could not reach the SDIP service.",
    reconnecting: "Connecting…",
    unauthorized: "Log in to continue.",
    insufficient: "Not enough data for this view yet.",
  },
  atlas: {
    title: "ATLAS Assistant", subtitle: "Explore matches and ATLAS analysis by conversation",
    placeholder: "Ask ATLAS about a match or market…",
    connectTitle: "Log in to continue",
    connectBody: "You need to log in to use the ATLAS Assistant. Once signed in you can explore matches and analysis by conversation.",
    connectCta: "Log in",
    suggestions: ["What did you find today?", "What are you watching live?", "Strongest prematch pick?", "What are the alternatives?", "Anything on the corners side?"],
  },
  result: { pending: "Pending", win: "Win", lose: "Lose", live: "Live" },
  live: {
    signalsTab: "ATLAS Signals", matchesTab: "Live Matches", resolvedTab: "Resolved",
    monitoringTitle: "ATLAS live monitoring",
    monitoringBody: "No active live signal right now. ATLAS keeps watching matches and will issue a signal once enough pressure builds.",
    fixturesUnavailable: "Showing the matches ATLAS is currently watching.",
    fixturesUnavailableHint: "Showing the matches ATLAS is currently watching. New matches appear here as they come under evaluation.",
    monitored: "Monitored", pending: "Active signals", resolvedToday: "Resolved today",
  },
  explorer: {
    exploreTab: "Match Explorer", picksTab: "ATLAS Picks", resolvedTab: "Resolved",
    today: "Today", tomorrow: "Tomorrow", next24: "24 Hours", all: "All",
    withAtlas: "With ATLAS pick", riskLevel: "Risk", market: "Market",
    noAtlas: "No ATLAS pick for this match",
    emptyExplorer: "No upcoming matches ATLAS is evaluating right now.",
  },
  analysis: {
    title: "My Analysis", subtitle: "Combine selections and review them together through ATLAS. This is not a betting tool.",
    empty: "Your analysis list is empty.",
    emptyHint: "Add live or prematch selections to your list to review them together.",
    analyze: "Analyze Combination", clear: "Clear list", remove: "Remove",
    overallRisk: "Overall risk profile", strongest: "Strongest selection", weakest: "Weakest selection",
    highVariance: "High-variance legs", marketConc: "Market concentration", leagueConc: "League concentration",
    timingConflict: "Timing conflict", reviewCandidates: "Review candidates",
    selections: "selections", notWager: "Analysis tool · not a wager",
    deepTitle: "ATLAS deep evaluation",
  },
  notifPrefs: {
    title: "Notification preferences", browser: "Browser notifications",
    enabled: "Enabled", permissionRequired: "Permission required", denied: "Denied", unsupported: "Unsupported",
    enable: "Enable notifications",
    followedTitle: "Followed matches", noFollowed: "You are not following any matches yet.",
    events: "Which events should we notify you about?",
  },
};
